import { Pipe, PipeTransform } from '@angular/core';
import type { NotificationFindInterface } from '@zaoblako/shared/modules/notification/dtos/notification-find.dto';

@Pipe({
  standalone: true,
  name: 'convertNotificationToLink'
})
export class ConvertNotificationToLinkPipe implements PipeTransform {
  public transform(notification: NotificationFindInterface): string {
    return (notification.subject?.link || '').replace(`${window.location.protocol}//${window.location.hostname}`, '');
  }
}
